"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useCheckmarkStyles_unstable", {
    enumerable: true,
    get: function() {
        return useCheckmarkStyles_unstable;
    }
});
const _react = require("@griffel/react");
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        a9b677: "fjw5fx7",
        Bqenvij: "fd461yt",
        Bcdw1i0: "fd7fpy0"
    },
    rootChecked: {
        Bcdw1i0: "f1022m68"
    }
}, {
    d: [
        ".fjw5fx7{width:16px;}",
        ".fd461yt{height:16px;}",
        ".fd7fpy0{visibility:hidden;}",
        ".f1022m68{visibility:visible;}"
    ]
});
const useCheckmarkStyles_unstable = (state)=>{
    const styles = useStyles();
    if (state.checkmark) {
        state.checkmark.className = (0, _react.mergeClasses)(styles.root, state.checked && styles.rootChecked, state.checkmark.className);
    }
}; //# sourceMappingURL=useCheckmarkStyles.styles.js.map
